module.exports = __webpack_public_path__ + "static/media/opensans-lightitalic-webfont.d920bf7a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/opensans-lightitalic-webfont.woff
// module id = 1016
// module chunks = 0